import React, { useState } from "react";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import VariantReward from "./Users/VariantReward";
import { fontSize } from "@mui/system";
import ImageGallery from "react-image-gallery";
// @ts-ignore - allow importing scss side-effect until a proper declaration file (*.d.ts) is added
import "react-image-gallery/styles/scss/image-gallery.scss";
import YouTube from 'react-youtube';
import { Sustainability } from "../Api/Database";

const sustainabiltyText: Sustainability = {
    recycled_biobased_material_share: "Recycled/biobased material share",
    energy_source_in_production: "Energy source in production",
    recyclability: "Recyclability",
    compliance_with_standards: "Compliance with standards",
    carbon_footprint: "Carbon footprint",
    carbon_footprint_reduction_renewables: "Carbon footprint reduction renewables"
}

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
}));

function ProductDetails(props: any) {

    //console.log(props);
    const sections: string[] = ["Product","Additional product info", "Sustainability", "Passport Owner Info"];

    const brandData = props.brandData;
    const productData = props.productData;

    const [expanded, setExpanded] = React.useState<string | false>(
        sections[0],
    );

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };


    function capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function is_empty(items: any) {
        return Object.keys(items).find((key) => items[key] !== '') !== undefined
    };

    function linkExtract(link:string){

        let cleanLink= link;

        if(cleanLink.includes("://")){
            cleanLink= cleanLink.split("://")[1];
        }

        if(cleanLink.includes("www.")){
            cleanLink= cleanLink.split("www.")[1];
        }

        if(cleanLink.includes("/")){
            cleanLink= cleanLink.split("/")[0];
        }
        
        return cleanLink;
    }

    const templates: ((props: any) => JSX.Element)[] = [
        (props: any): JSX.Element => {
            //console.log("props", props)
            return (
                <div className="product-details">
                    <h2 className="sub-title" style={{ fontSize: "16px" }}>{props.product_name}</h2>
                    <p><i>{props.product_description}</i></p>

                    {props.image &&  <>
                        
                        {(props.images && props.images.length > 0) && <>
                            <h2 className="sub-title">PICTURES GALLERY: </h2>
                            <ImageGallery items={props.images} showFullscreenButton={false} showPlayButton={false} showThumbnails={false} />
                        </>}
                        {/*<p style={{wordBreak:"break-word"}}><a href={props.image} target={"_blank"}>{props.image}</a></p>*/}
                    </>}

                    {/*props.user_manual && is_empty(props.user_manual) && <>
                        <h2 className="sub-title">USER MANUAL: </h2>
                        <ul>
                            {Object.keys(props.user_manual).filter((key) => props.user_manual[key] !== "").map(
                                (key: any) => <li key={key}><a href={props.user_manual[key]} target={"_blank"}>{capitalizeFirstLetter(key).replaceAll("_", " ")}</a></li>)}
                        </ul>
                    </>*/}

                    {/*props.sustainability_info && is_empty(props.sustainability_info) && <>
                        <h2 className="sub-title">SUSTAINABILITY INFO: </h2>
                        <ul>
                            {Object.keys(props.sustainability_info).filter((key) => props.sustainability_info[key] !== "").map((key: any) => <li key={key}>
                                {key === "ways_of_recycling" ? <>
                                    {sustainabiltyText[key] + ": "} <a href={props.sustainability_info[key]} target="_blank">{props.sustainability_info[key]}</a>
                                </> : <>
                                    {sustainabiltyText[key] + ": " + props.sustainability_info[key]}
                                </>}

                            </li>)}
                        </ul>
                    </>*/}

                    {props.awards && Object.keys(props.awards).length !== 0 && <>
                        <h2 className="sub-title">AWARDS: </h2>
                        <div>
                            {Object.keys(props.awards).filter((key) => props.awards[key] !== "").map((key: any, index: number) => <VariantReward key={"x_" + index} data={props.awards[key]} num={index} showEmpty={false}></VariantReward>)}
                        </div>
                    </>}

                    {productData.shop_url != "" ?  <>
                       
                        <h2 className="sub-title">SHOP LINK: </h2>
                        <button className="shop_btn" onClick={() => {window.open(productData.shop_url)}}>Shop now in your country</button>    
                    </>: <></>}
                    

                    <h2 className="sub-title">COMPANY: </h2>
                    <p>{brandData.name != "" && brandData.website_url != "" ? <>{brandData.name +" | "} <a href={brandData.website_url} target='_blank'>{linkExtract(brandData.website_url)}</a> </> : "N/A" }</p>    

                    <h2 className="sub-title">COMPANY LOCATION: </h2>
                    <p>{brandData.location != "" ? brandData.location : "N/A"}</p>    
                </div>
            )
        },
        
        (props: any): JSX.Element => {
            return (
                <div className="product-details">
                    <h2 className="sub-title" style={{ fontSize: "16px" }}>{props.product_name}</h2>
                    <p><i>{props.product_description}</i></p>

                    {props.user_manual && is_empty(props.user_manual)  ? <>
                        
                        {Object.keys(props.user_manual).filter((key) => props.user_manual[key] !== "").map((key: any) => {
                            // It contains youtube link -> show video 
                            if(props.user_manual[key].includes("youtube") && props.user_manual[key].includes("/watch?v=")){
                                props.user_manual[key] = "https://youtube.com/embed/"+props.user_manual[key].split("/watch?v=")[1];
                            }

                            if(props.user_manual[key].includes("youtube") && props.user_manual[key].includes("embed")){
                                let videoUrl =props.user_manual[key].split("embed/")[1]
                                //let videoUrl =props.user_manual[key]
                             
                                return (<span key={key+"info"}>
                                     <h2 className="sub-title">{(key).toUpperCase().replaceAll("_", " ")}:</h2> 
                                    { videoUrl && <div className="video-container" style={{marginTop:"10px", textAlign:"center",}}>
                                        {/*<h3 style={{textAlign:"left", paddingLeft:"46px"}}>Thank You from {brandData.name}</h3>*/}
                                        <YouTube videoId={videoUrl} opts={{
                                            width: '100%',
                                            height: '200',
                                            playerVars: {
                                                // https://developers.google.com/youtube/player_parameters
                                                autoplay: 0,
                                            },
                                        }} onReady={() => {
                                                
                                        }}></YouTube>
                                    </ div>}
                                </span>)
                            }
                            // Show link
                            return (<span key={key+"info"}>
                                <h2 className="sub-title">{(key).toUpperCase().replaceAll("_", " ")}:</h2> <a  style={{wordBreak:"break-all"}} href={props.user_manual[key]} target={"_blank"}>Click here to see {key.replaceAll("_", " ")}</a>
                            </span>)
                        })}
                    </>:<>No information</>}
                   
                </div>
            )
        },
        
        (props: any): JSX.Element => {
            return (
                <div className="product-details">
                    <h2 className="sub-title" style={{ fontSize: "16px" }}>{props.product_name}</h2>
                    <p><i>{props.product_description}</i></p>

                    {props.sustainability_info && is_empty(props.sustainability_info) ? <>
                        
                        {Object.keys(props.sustainability_info).filter((key) => props.sustainability_info[key as keyof typeof props.sustainability_info] !== "").map((key) => {
                            const k = key as keyof Sustainability;
                            /* if (k === "ways_of_recycling") {
                                return <span key={key}>
                                    <h2 className="sub-title">{sustainabiltyText[k]}: </h2>  <a href={props.sustainability_info[k]} target="_blank" rel="noopener noreferrer">Click here to see {(k as string).replaceAll("_", " ")}</a>
                                </span>
                            } */
                            return <span key={key}>
                                <h2 className="sub-title">{sustainabiltyText[k]}:</h2> {props.sustainability_info[k]}
                            </span>
                        })}
                    </>:<>No information</>}

                   
                </div>
            )
        },
        (props: any): JSX.Element => {
            return (
                <div className="product-details">
                    <h2 className="sub-title" style={{ fontSize: "16px" }}>{props.official_name}</h2>
                    <h2 className="sub-title"><a href={props.official_website} target="_blank">{props.official_website}</a></h2>
                    <h2></h2><p>{props.summary}</p>
                    <h2 className="sub-title">LOCATION: </h2><p>{props.location_country}</p>

                    {props.location_iso && <>
                        <h2 className="sub-title">LOCATION ISO: </h2><p>{props.location_iso}</p>
                    </>}

                    {props.bussiness_registry_info && <>
                        <h2 className="sub-title">BUSINESS REGISTRY INFO: </h2><a href={props.bussiness_registry_info} target="_blank">{props.bussiness_registry_info}</a>
                    </>}
                    {props.eori && <>
                        <h2 className="sub-title">EORI: </h2><p>{props.eori}</p>
                    </>}
                </div>
            )
        }
    ];

    const templateData = [
        {
            product_name: productData.title,
            product_description: productData.description,
            image: productData.image_gallery,
            images: props.images,
            user_manual: productData.user_manual,
            sustainability_info: productData.sustainability,
            awards: productData.awards,
        },
        {
            user_manual: productData.user_manual,
        },
        {
            sustainability_info: productData.sustainability,
        },{
            official_name: brandData.name,
            official_website: brandData.website_url,
            summary: brandData.summary,
            location_country: brandData.location,
            location_iso: brandData.location_iso,
            bussiness_registry_info: brandData.business_registry_info,
            eori: brandData.eori,
        }
    ];

    return (
        < >

            {sections.map((prettyName, index) => (
                
                    <Accordion
                        expanded={expanded === prettyName}
                        onChange={handleChange(prettyName)}
                        key={index}
                        sx={{ width: "80%", margin: "auto" }}
                        className={ `${props.add_space && prettyName === "Passport Owner Info" ? "add_space" : ""} `}
                        id={prettyName}
                    >
                        <MuiAccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{ minHeight: "38px" }}
                        >
                            <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                                {prettyName}
                            </Typography>
                        </MuiAccordionSummary>
                        <AccordionDetails>
                            {templates[index](templateData[index])}
                        </AccordionDetails>
                    </Accordion>
                
            ))}
        </>
    );
}

export default ProductDetails;
